import recentsLT from "../data/lt/recents.json";
import recentsEN from "../data/en/recents.json";
import productsLT from "../data/lt/products.json";
import productsEN from "../data/en/products.json";
import eshopLT from "../data/lt/eshop.json";
import eshopEN from "../data/en/eshop.json";
import commonEN from "../data/en/common.json";
import commonLT from "../data/lt/common.json";
import homeLT from "../data/lt/home.json";
import homeEN from "../data/en/home.json";
import galleryLT from "../data/lt/gallery.json";
import galleryEN from "../data/en/gallery.json";
import playgroundsLT from "../data/lt/playground.json";
import playgroundsEN from "../data/en/playground.json";
import outdoorSportsLT from "../data/lt/outdoorSports.json";
import outdoorSportsEN from "../data/en/outdoorSports.json";
import safeCoatingsLT from "../data/lt/safeCoatings.json";
import safeCoatingsEN from "../data/en/safeCoatings.json";
import functionalControlLT from "../data/lt/functionalControl.json";
import functionalControlEN from "../data/en/functionalControl.json";

export type TranslationResources = Record<string, Record<string, unknown>>;

export const translationNamespaces = [
  "common",
  "home",
  "playgrounds",
  "outdoorSports",
  "safeCoatings",
  "eshop",
  "products",
  "gallery",
  "recents",
  "functionalControl",
];

export const staticFallbacks: Record<string, TranslationResources> = {
  en: {
    common: commonEN,
    home: homeEN,
    playgrounds: playgroundsEN,
    outdoorSports: outdoorSportsEN,
    gallery: galleryEN,
    recents: recentsEN,
    safeCoatings: safeCoatingsEN,
    eshop: eshopEN,
    products: productsEN,
    functionalControl: functionalControlEN,
  },
  lt: {
    common: commonLT,
    home: homeLT,
    playgrounds: playgroundsLT,
    outdoorSports: outdoorSportsLT,
    gallery: galleryLT,
    recents: recentsLT,
    safeCoatings: safeCoatingsLT,
    eshop: eshopLT,
    products: productsLT,
    functionalControl: functionalControlLT,
  },
};
